import { useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import Menu from "../components/Menu";
import { DefeitoDiario } from "../components/Tabelas/DefeitoDiario";

import api from "../services/api";

export default function RelatorioDefeitosDiario() {
    const [data, setData] = useState(null);
    const [date, setDate] = useState(new Date());

    const toast = useRef(null);

    const handleSearch = () => {
        let formated1 = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
        
        api.get(`defeitos/relatorio-diario/${formated1}`).then((response) => {
            setData(response.data);
            toast.current.show({ summary: 'Concluído', severity: 'success', detail: 'Relatório gerado com sucesso.' });
        }).catch((error) => {
            toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
        });
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card className="p-m-3" title="Relatório Diário de Defeitos">
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12 p-md-2">
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setDate(e.value)}
                            placeholder="Data Inicial: "
                            value={date}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <Button className="p-button-primary" icon="pi pi-search" onClick={handleSearch} />
                    </div>
                </div>

                <DefeitoDiario
                    data={data ? data.dados : null}
                    totalGeral={data ? data.total_geral : null}
                    date={date.toLocaleDateString("pt-BR")}
                />

            </Card>
        </div>
    )
}